import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map, delay } from 'rxjs/operators';
import { APIResponse } from './api.interfaces';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

/**
 * Auth API レスポンスデータ部
 */
export interface AuthData {
  token: string;
}

/**
 * Authサービス
 */
@Injectable()
export class AuthService {
  /**
   * コンストラクタ
   */
  constructor(
    private http: HttpClient
  ) { }

  /**
   * ログインAPIコール
   */
  login(uid: string, pass: string): Observable<APIResponse<AuthData[]>> {
    // 外部通信なし
    // return from([1]).pipe(
    //   delay(2000),
    //   map(() => {
    //     return {
    //       result_code: '00',
    //       error_message: '',
    //       data: [{
    //         token: user_id + ':' + password
    //       }]
    //     };
    //   })
    // );

    // ↓ 通信するバージョン
    return this.http.post(
      environment.apiHost + '/login',
      {
        user_id: uid,
        password: pass
      },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        responseType: 'json'
      }
    ).pipe<APIResponse<AuthData[]>>(
      map((json:{access_token:string}) => {
        //console.log(json);
        return {
          result_code: '00',
          error_message: '',
          data: [{
            token: json.access_token
          }]
        };
      }),
    );

  }

  /**
   * ログアウトAPIコール
   */
  logout(): Observable<APIResponse<{}>> {
    // TODO 実際のAPIが出来たらHttpClientにする
    return from([1]).pipe(
      delay(1000),
      map(() => {
        return {
          result_code: '00',
          error_message: '',
          data: {}
        };
      })
    );
  }
}
